// TODO: use proper i18n functionality once integrated.
// eslint-disable-next-line camelcase

export const SUBSCRIPTION = {
  free: 'free',
  pro: 'pro',
  enterprise: 'enterprise',
} as const;

export const TMP_formatNumber = new Intl.NumberFormat('en-US').format;
